module.exports = __webpack_public_path__ + "static/link-somewhereelse-do-87faaee4e178eb79b4e34123bcb83520.png";